module.exports = __webpack_public_path__ + "static/img/arrow.858b17a0.png";